import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1052"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M1.586 12.321c.091.016 1.427.24 2.99.24 1.019 0 2.134-.095 3.062-.405 3.753-1.253 6.211.066 6.312.123a.7.7 0 1 0 .689-1.219c-.094-.053-1.819-.999-4.561-.812l2.806-2.981a.194.194 0 0 0-.141-.327h-1.28a.063.063 0 0 1-.053-.098l1.217-1.475a.136.136 0 0 0-.114-.21h-2.21a.234.234 0 0 0-.203.119L8.463 7.822a.194.194 0 0 0 .17.288h1.308c.042 0 .073.041.061.081l-.619 2.128c-.68.091-1.409.249-2.187.509-.876.293-1.996.354-2.986.329l1.308-4.461 6.731-3.314a.377.377 0 0 0-.062-.7L6.381 1.031a.693.693 0 0 0-.804.48l-2.8 9.552a16.187 16.187 0 0 1-.955-.123.71.71 0 0 0-.808.572.7.7 0 0 0 .572.809zm13.054 1.182c-.123-.069-3.069-1.692-7.444-.232-2.02.676-5.34.119-5.373.113a.708.708 0 0 0-.808.572.7.7 0 0 0 .571.808c.091.016 1.427.24 2.99.24 1.019 0 2.134-.095 3.062-.405 3.753-1.253 6.211.067 6.312.123a.698.698 0 0 0 .954-.265.699.699 0 0 0-.264-.954z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }